import { Box, styled } from '@mui/material';
import { chromeYellow, spaceCadet } from '../../utils/colors';

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  height: '100vh',

  '& > .MuiBox-root.header': {
    flexShrink: 0,
    backgroundColor: spaceCadet[700],
    padding: '12px 12px',
    borderBottom: `2px solid ${chromeYellow[500]}`,
    zIndex: theme.zIndex.modal + 2,
    '& .MuiTypography-h1': {
      fontSize: 14,
      lineHeight: '24px',
      fontWeight: 600,
      color: spaceCadet[100],
      textAlign: 'center',
    },
  },

  '& > .MuiBox-root.main': {
    display: 'flex',
    flexDirection: 'row',
    gap: 0,
    alignItems: 'stretch',
    flexGrow: 1,

    '& > .drawer-placeholder': {
      backgroundColor: spaceCadet[600],
      width: 36,
      flexShrink: 0,
      zIndex: theme.zIndex.modal + 2,
    },
    '& > .MuiBox-root.content': {
      flexGrow: 1,
    },
  },
}));

export default StyledBox;
